import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { partnerPortalApi } from '../../api/partnerPortal';

export function PartnerResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const { register, handleSubmit, formState: { isSubmitting } } = useForm<{ newPassword: string; confirmPassword: string }>();

  const onSubmit = async (values: { newPassword: string; confirmPassword: string }) => {
    setError(null);
    if (values.newPassword !== values.confirmPassword) { setError('Passwords do not match.'); return; }
    if (!token) { setError('No reset token was provided.'); return; }
    try {
      await partnerPortalApi.resetPassword(token, values.newPassword);
      navigate('/login');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to reset password.');
    }
  };

  return (
    <div className="login-page">
      <div className="card" style={{ maxWidth: 420, margin: '80px auto', borderTop: '4px solid var(--vri-green)' }}>
        <h1>Set a New Password</h1>
        <form onSubmit={handleSubmit(onSubmit)}>
          <label>New Password<input type="password" autoFocus {...register('newPassword', { required: true, minLength: 8 })} /></label>
          <label>Confirm New Password<input type="password" {...register('confirmPassword', { required: true })} /></label>
          {error && <p className="field-error">{error}</p>}
          <div className="form-actions"><button type="submit" disabled={isSubmitting}>{isSubmitting ? 'Saving…' : 'Set New Password'}</button></div>
        </form>
        <p className="muted" style={{ fontSize: 13, marginTop: '1.5em' }}><Link to="/login">Return to sign in</Link></p>
      </div>
    </div>
  );
}
